export default "__VITE_ASSET__CxcKulPX__"